import { useMediaLibDialogCtx } from "@editor/modules/media-lib/ctx";
import {
  type IMediaLibDialogItem,
  MediaLibPresetEnum,
} from "@editor/modules/media-lib/types";
import type { IMediaFile } from "@/shared/types";
import { prepBlurhashUrl } from "@/shared/utils";
import { AiImage } from "../../ai-image";

export const MediaDialogAi = () => {
  const { isMultiSelect, onSelect, onMultiSelect, preset } =
    useMediaLibDialogCtx();

  const handleSelect = (mediaFile: IMediaFile) => {
    if (preset === MediaLibPresetEnum.OnlyVideos) return;
    let url = mediaFile.url;
    if (mediaFile.metadata?.imageBlurhash) {
      url = prepBlurhashUrl(url, mediaFile.metadata.imageBlurhash);
    }
    const media: IMediaLibDialogItem = {
      id: mediaFile._id,
      url,
      type: "image",
      mediaFrom: "ai-generate",
    };
    if (isMultiSelect) onMultiSelect([media]);
    else onSelect(media);
  };
  return <AiImage onSelect={handleSelect} view="dialog" />;
};
